// @ts-nocheck
import $ from 'jquery';
import * as Survey from 'survey-react';
import * as SurveyCore from 'survey-core';
import * as widgets from 'surveyjs-widgets';
// import 'survey-react/survey.css';

// widgets.icheck(SurveyCore, $);
widgets.prettycheckbox(SurveyCore);
widgets.select2(SurveyCore, $);
widgets.inputmask(SurveyCore);
widgets.jquerybarrating(SurveyCore, $);
widgets.jqueryuidatepicker(SurveyCore, $);
widgets.nouislider(SurveyCore);
widgets.select2tagbox(SurveyCore, $);
//widgets.signaturepad(SurveyCore);
widgets.sortablejs(SurveyCore);
widgets.ckeditor(SurveyCore);
widgets.autocomplete(SurveyCore, $);
widgets.bootstrapslider(SurveyCore);

export const savePDF = ({ json, data, exportFilled }: { json: any; data: any; exportFilled: boolean }) => {
  const title = '';

  const options = {
    haveCommercialLicense: true,
    fontSize: 14,
    textFieldRenderAs: 'multiLine',
    margins: {
      left: 10,
      right: 10,
      top: 10,
      bot: 10,
    },
  };

  Survey.StylesManager.applyTheme('modern');
  // Survey.StylesManager.applyTheme('defaultV2');
  window.SurveyPDF.SurveyHelper.FORM_BORDER_VISIBLE = true;
  window.SurveyPDF.SurveyHelper.FORM_BORDER_COLOR = 'gray';
  window.SurveyPDF.SurveyHelper.VALUE_READONLY_PADDING_SCALE = 0;
  window.SurveyPDF.SurveyHelper.DESCRIPTION_FONT_SIZE_SCALE = 1;
  window.SurveyPDF.SurveyHelper.MULTIPLETEXT_TEXT_PERS = 1;
  window.SurveyPDF.FlatQuestion['CONTENT_GAP_HOR_SCALE'] = 1;
  window.SurveyPDF.FlatQuestion['CONTENT_GAP_VERT_SCALE'] = 0.1;
  window.SurveyPDF.SurveyHelper.TEXT_COLOR = '#43454B';

  SurveyCore.Serializer.addProperty('question', {
    name: 'category:text',
    category: 'general',
  });
  SurveyCore.Serializer.addProperty('question', {
    name: 'questionNumber:text',
    category: 'general',
  });

  const surveyModel = new SurveyCore.SurveyModel(json);
  surveyModel.data = data;
  const surveyPDF = new window.SurveyPDF.SurveyPDF(json, options);
  surveyPDF.mode = 'display';
  surveyPDF.showInvisibleElements = true;

  if (exportFilled) {
    surveyPDF.data = data;
    surveyPDF.save();
  } else {
    surveyPDF.save();
  }

  surveyPDF.getAllQuestions().map((question: any) => {
    question.hideNumber = false;
    question.name = question.name.replace('PCR_Q', '').replace(/_/g, '.');

    //question.title = question.title;
    if (question.category === 'Bronze' || question.category === 'Silver' || question.category === 'Gold') {
      question.description = question.category;
    } else {
      question.description = '';
    }
    question.descriptionLocation = 'underInput';

    return question;
  });

  surveyPDF.onRenderPage.add(function(_, options) {
    const pageTitleBricks = options.bricks[0].unfold();
    pageTitleBricks
      .filter(brick => brick instanceof SurveyPDF.RowlineBrick)
      .forEach(brick => (brick.color = SurveyPDF.SurveyHelper.FORM_BORDER_COLOR));
  });

  surveyPDF.onRenderHeader.add(function(_, canvas) {
    const controller: SurveyPDF.DocController = new SurveyPDF.DocController({
      fontSize: 8,
      margins: {
        left: 30,
        right: 10,
        top: 5,
        bot: 10,
      },
    });

    if (canvas.pageNumber === 1) {
      canvas.drawText({
        text: `${title}`,
        fontSize: 8,
        isBold: true,
        horizontalAlign: SurveyPDF.HorizontalAlign.Left,
        verticalAlign: SurveyPDF.VerticalAlign.Top,
        rect: SurveyPDF.SurveyHelper.createHeaderRect(controller),
        margins: {
          top: 5,
          left: 30,
        },
      });
    }

    canvas.packs.unshift(canvas.packs.pop());
  });

  surveyPDF.onRenderPanel.add(function(_, options) {
    try {
      var b = options.bricks[0].unfold()[0];
      b.xRight = options.controller.paperWidth - 20;
      var tq = Survey.Serializer.createClass('empty');
      tq.readonlyRenderAs = 'acroform';
      tq.value = 'gray';
      var panelTitleBack = new options.module.TextFieldBrick(
        tq,
        b.controller,
        { xLeft: b.xLeft, yTop: b.yTop, xRight: b.xRight, yBot: b.yBot },
        false,
        tq.id,
        '',
        '',
        true,
        false,
        'color'
      );
      options.bricks.unshift(panelTitleBack);
      for (var brickLstI in options.bricks) {
        var unfoldBricks = options.bricks[brickLstI].unfold();
        for (var brickI in unfoldBricks) {
          if (unfoldBricks[brickI] instanceof options.module.TitlePanelBrick) {
            unfoldBricks[brickI].textColor = 'white';
          }
        }
      }
    } catch (error) {
      console.log('error', error && (error as any).message);
    }
  });

  surveyPDF.onRenderPage.add(function(_, options) {
    const pageTitleBricks = options.bricks[0].unfold();
    pageTitleBricks
      .filter(brick => brick instanceof SurveyPDF.RowlineBrick)
      .forEach(brick => (brick.color = SurveyPDF.SurveyHelper.FORM_BORDER_COLOR));
  });

  surveyPDF.onRenderFooter.add(function(_, canvas) {
    canvas.drawText({
      text: canvas.pageNumber + '/' + canvas.countPages,
      fontSize: 8,
    });
  });
};
